/**
 * Adds the main product plus any ticked add-ons to the cart in a single
 * request, then sends the shopper wherever the section is configured to.
 *
 * Uses Shopify's own /cart/add.js, so no bundling app is required.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-nova-buy]').forEach(setup);
  });

  function setup(root) {
    var button = root.querySelector('[data-nova-add]');
    var label = root.querySelector('[data-nova-label]');
    var error = root.querySelector('[data-nova-error]');
    var section = root.closest('section');

    if (!button || !section) return;

    var original = label ? label.textContent.trim() : '';

    button.addEventListener('click', function () {
      var tier = section.querySelector('.nova-tier__box:checked');
      var quantity = tier ? Number(tier.value) || 1 : 1;
      var items = [{ id: Number(root.dataset.variant), quantity: quantity }];

      section.querySelectorAll('.nova-addon__box:checked').forEach(function (box) {
        var id = Number(box.value);
        if (id) items.push({ id: id, quantity: 1 });
      });

      setBusy(true);
      hideError();

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error(body.description || body.message || 'That could not be added.');
            return body;
          });
        })
        .then(function () {
          var next = root.dataset.redirect;
          if (next === 'drawer' || !next) {
            setBusy(false);
            if (label) label.textContent = original;
            document.dispatchEvent(new CustomEvent('nova:cart-updated'));
          } else if (next === 'checkout') {
            window.location.href = '/checkout';
          } else if (next === 'cart') {
            window.location.href = '/cart';
          } else {
            setBusy(false);
            if (label) {
              label.textContent = 'Added';
              window.setTimeout(function () { label.textContent = original; }, 2000);
            }
            document.dispatchEvent(new CustomEvent('nova:cart-updated'));
          }
        })
        .catch(function (err) {
          setBusy(false);
          showError(err.message);
        });
    });

    function setBusy(state) {
      button.disabled = state;
      button.setAttribute('aria-busy', state ? 'true' : 'false');
      if (label && state) label.textContent = 'Adding…';
      if (label && !state && label.textContent === 'Adding…') label.textContent = original;
    }

    function showError(message) {
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    }

    function hideError() {
      if (!error) return;
      error.hidden = true;
      error.textContent = '';
    }
  }
})();
